import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PHOTO1 from '../Assets/PHOTO1.jpg';
import PHOTO2 from '../Assets/PHOTO2.jpg';
import PHOTO3 from '../Assets/PHOTO3.jpg';

const PhotoGallery = () => {
  const photos = [PHOTO1, PHOTO2, PHOTO3];
  const texts = [
    {
      badge: '501(c)(3) NON-PROFIT ORGANIZATION',
      header: 'WHO WE ARE',
      spanText: 'Youth L.I.F.E. Support Network, Inc. is a community-based non-profit organization focused on public safety, youth empowerment, and working with high-risk youth & families.',
      primaryBtnText: 'Explore Programs',
      primaryBtnLink: '/programs',
      secondaryBtnText: 'Our Mission',
      secondaryBtnLink: '/about'
    },
    {
      badge: 'EMPOWERING THE NEXT GENERATION',
      header: 'WE BELIEVE',
      spanText: 'Youth are the leaders of tomorrow. We work collectively to empower their visions, nurture ambition, and provide life-changing resources.',
      primaryBtnText: 'Get Involved',
      primaryBtnLink: '/events',
      secondaryBtnText: 'View Programs',
      secondaryBtnLink: '/programs'
    },
    {
      badge: 'STRONG COMMUNITY COLLABORATION',
      header: 'COMMUNITY & L.I.F.E.',
      spanText: 'Without a strong network of support, there can be no true success. Together, we build safer, stronger, and more resilient communities.',
      primaryBtnText: 'Contact Us',
      primaryBtnLink: '/contact',
      secondaryBtnText: 'Learn About Us',
      secondaryBtnLink: '/about'
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % photos.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [photos.length]);

  const nextPhoto = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % photos.length);
  };

  const prevPhoto = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + photos.length) % photos.length);
  };

  return (
    <div className='photo-gallery'>
      <div className='photo-container'>
        <img src={photos[currentIndex]} alt={`Slide ${currentIndex + 1}`} />
        <div className="overlay">
          <span className="hero-badge">{texts[currentIndex].badge}</span>
          <h2>{texts[currentIndex].header}</h2>
          <span>{texts[currentIndex].spanText}</span>
          <div className="hero-cta-buttons">
            <Link to={texts[currentIndex].primaryBtnLink} className="hero-btn primary">
              {texts[currentIndex].primaryBtnText} <i className="fa-solid fa-arrow-right"></i>
            </Link>
            <Link to={texts[currentIndex].secondaryBtnLink} className="hero-btn secondary">
              {texts[currentIndex].secondaryBtnText}
            </Link>
          </div>
        </div>
        
        <div className='photo-controls'>
          <button onClick={prevPhoto} aria-label="Previous Slide">
            <i className="fa-solid fa-chevron-left"></i>
          </button>
          <button onClick={nextPhoto} aria-label="Next Slide">
            <i className="fa-solid fa-chevron-right"></i>
          </button>
        </div>

        <div className="hero-slide-dots">
          {photos.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PhotoGallery;